export type SendNotificationFilter =
    | "registryFilter"
    | "roleFilter"
    | "settlementsFilter"
    | "countyFilter";

export type SentNotificationsFilter =
    | "priorityFilter"
    | "severityFilter"
    | "professionalFieldFilter";

export type NotificationTemplatesFilter =
    | "authorFilter"
    | "severityFilter"
    | "priorityFilter"
    | "professionalFieldFilter"
    | "isSharedFilter";

export type UserNotificationsFilter = "isHighlightedFilter" | "sourceFilter" | "isReadFilter";

export type UserAdministrationFilter = "roleFilter" | "countyFilter" | "statusFilter";

export type UserActivityFilter = "roleFilter" | "platformFilter" | "actionFilter";

export type OuterModulesFilter = "statusFilter";

export interface DateFilter {
    from: Date;
    to: Date;
}

export const mapToFilterName = <T>(moduleName: string, filter: T) => {
    return `${moduleName}-${filter}`;
};

export interface PaginatedFilterRequest {
    page: number;
    pageSize: number;
}

export interface SortFilterRequest {
    sortField?: string;
    descending?: boolean;
}
